import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import Checkbox from '../../common/Checkbox'
import Input from '../../common/Input'

import * as Strings from './strings'

class UserModal extends Component {
  render() {
    const {
      show,
      hide,
      emailInput,
      passwordInput,
      isAdmin,
      classes,
      header,
      information,
      onDone,
      onChangeEmailInput,
      onChangePasswordInput,
      onChangeIsAdmin,
      errorEmail,
      errorPassword,
      withPassword,
      loading = false,
      errorMessage = '',
      extraInformation = ''
    } = this.props

    return (
      <Dialog open={show} aria-labelledby={'form-dialog-title'}>
        <DialogTitle id={'form-dialog-title'}>{header}</DialogTitle>
        <DialogContent>
          <DialogContentText>{information}</DialogContentText>
          {extraInformation === '' ? null : (
            <p style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.54)' }}>
              {extraInformation}
            </p>
          )}
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <Input
            placeholder={Strings.default.EMAIL + '*'}
            value={emailInput}
            onChange={text => onChangeEmailInput(text)}
            error={errorEmail}
          />
          {withPassword ? (
            <Input
              placeholder={Strings.default.PASSWORD + '*'}
              value={passwordInput}
              onChange={text => onChangePasswordInput(text)}
              error={errorPassword}
            />
          ) : null}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Checkbox
              placeholder={Strings.default.ADMIN}
              checked={isAdmin}
              onChange={checked => onChangeIsAdmin(checked)}
              style={{ marginTop: 15 }}
            />
          </div>
        </DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => hide()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => onDone()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

export default withStyles(Styles)(UserModal)



// WEBPACK FOOTER //
// ./src/components/common/UserModal/index.js